import type React from 'react';

import { DialogTitle } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useTranslation } from 'react-i18next';

import StandardButton from 'components/buttons/StandardButton';
import TMXDialog from 'components/dialogs/TMXDialog';
import { BodyLarge, H3 } from 'components/typography/Typography';

interface DeleteAvoidanceDialogProps {
  loading?: boolean;
  open?: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteAvoidanceDialog: React.FC<React.PropsWithChildren<DeleteAvoidanceDialogProps>> = ({
  loading,
  open,
  onDelete,
  onClose,
}) => {
  const paperProps = { style: { padding: 30 } };
  const { t } = useTranslation();

  const handleDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <TMXDialog fullWidth open={open} PaperProps={paperProps} onClose={onClose}>
      <DialogTitle>
        <H3>{t('deleteAvoidance')}</H3>
      </DialogTitle>
      <DialogContent>
        <BodyLarge>{t('deleteAvoidanceQuestion')}</BodyLarge>
      </DialogContent>
      <DialogActions>
        <StandardButton onClick={onClose}>{t('cancel')}</StandardButton>
        <StandardButton loading={loading} variant="warning" onClick={handleDelete}>
          {t('delete')}
        </StandardButton>
      </DialogActions>
    </TMXDialog>
  );
};

export default DeleteAvoidanceDialog;
